import UILink from 'UIComponents/link/UILink';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIBox from 'UIComponents/layout/UIBox';
import { usePublicCatalogFilters } from '../../publicCatalogQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import usageTracker from '../../../../utils/usageTracker';
import MenuContent from './MenuContent';
import I18n from 'I18n';
import { useGetMenuStateContextWithValue, useMenuStateContext } from './mobileCategoriesMenuStateContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const MENU_TRANSITION_ANIMATION_MS = 300;
const MenuModal = styled.div.withConfig({
  displayName: "PublicCatalogMobileCategoriesMenu__MenuModal",
  componentId: "sc-3hwomf-0"
})(["overflow:auto;background-color:", ";color:", ";height:100vh;width:100vw;position:fixed;top:0;left:0;transition:transform ", "ms ease;transform:translateY(100vh);z-index:99;&.open{transform:translateY(0);}"], theme.colors.OLAF, theme.colors.OBSIDIAN, MENU_TRANSITION_ANIMATION_MS);
const StickyHeaderWrapper = styled.div.withConfig({
  displayName: "PublicCatalogMobileCategoriesMenu__StickyHeaderWrapper",
  componentId: "sc-3hwomf-1"
})(["position:sticky;top:0;z-index:1;"]);
const MenuHeader = styled.header.withConfig({
  displayName: "PublicCatalogMobileCategoriesMenu__MenuHeader",
  componentId: "sc-3hwomf-2"
})(["background-color:", ";color:", ";font-weight:500;"], theme.colors.OBSIDIAN, theme.colors.OLAF);
export const MenuHeading = styled.div.withConfig({
  displayName: "PublicCatalogMobileCategoriesMenu__MenuHeading",
  componentId: "sc-3hwomf-3"
})(["background-color:", ";border-bottom:1px solid ", ";font-weight:500;"], theme.colors.GYPSUM, theme.colors.GREAT_WHITE);
const PublicCatalogMobileCategoriesMenu = ({
  buttonText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.catalogPage.filters.browseCatalog"
  }),
  buttonUse = 'link'
}) => {
  const {
    filtersData,
    filtersError,
    filtersLoading
  } = usePublicCatalogFilters();
  const {
    openMenuModal,
    closeMenuModal,
    closeSubMenu,
    menuModalRef,
    isMenuModalRendered,
    isMenuOpen,
    isSubMenuOpen,
    activeSubMenu
  } = useMenuStateContext();
  const handleOpenMenuClick = () => {
    openMenuModal();
    usageTracker.track('interaction', {
      action: 'open-mobile-catalog-categories-menu'
    });
  };
  const handleCloseMenuClick = () => {
    closeMenuModal();
    usageTracker.track('interaction', {
      action: 'close-mobile-catalog-categories-menu'
    });
  };
  const handleBackButtonClick = () => {
    closeSubMenu();
    usageTracker.track('interaction', {
      action: 'mobile-catalog-categories-back-button-click'
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [buttonUse === 'link' && /*#__PURE__*/_jsx(UILink, {
      className: "p-x-4 p-y-3",
      onClick: handleOpenMenuClick,
      use: "on-dark",
      children: buttonText
    }), buttonUse === 'dropdown' && /*#__PURE__*/_jsxs(UILink, {
      onClick: handleOpenMenuClick,
      style: {
        display: 'inline-block',
        lineHeight: 1
      },
      children: [buttonText, /*#__PURE__*/_jsx(UIIcon, {
        className: "m-left-1",
        name: "downCarat",
        size: 12,
        style: {
          verticalAlign: 'middle'
        }
      })]
    }), isMenuModalRendered && /*#__PURE__*/_jsxs(MenuModal, {
      "aria-hidden": !isMenuOpen,
      "aria-modal": "true",
      className: `text-left ${isMenuOpen ? 'open' : ''}`,
      "data-test-id": "mobile-catalog-categories-menu",
      ref: menuModalRef,
      role: "dialog",
      children: [/*#__PURE__*/_jsx(StickyHeaderWrapper, {
        children: /*#__PURE__*/_jsx(MenuHeader, {
          children: /*#__PURE__*/_jsxs(UIFlex, {
            align: "center",
            className: "p-x-1 p-y-2",
            justify: "between",
            children: [/*#__PURE__*/_jsx(UIBox, {
              children: isSubMenuOpen && /*#__PURE__*/_jsxs(UIButton, {
                className: "p-x-3 p-y-2",
                onClick: handleBackButtonClick,
                use: "unstyled",
                children: [/*#__PURE__*/_jsx(UIIcon, {
                  color: theme.colors.OLAF,
                  name: "left",
                  size: 22
                }), /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.catalogPage.filters.backButton"
                })]
              })
            }), /*#__PURE__*/_jsx(UIBox, {
              grow: 0,
              children: /*#__PURE__*/_jsx(UIButton, {
                "aria-label": I18n.text('academyPublic.catalogPage.filters.closeMobileMenuButton'),
                className: "p-all-2",
                onClick: handleCloseMenuClick,
                use: "link-on-dark",
                children: /*#__PURE__*/_jsx(UIIcon, {
                  color: theme.colors.OLAF,
                  name: "remove",
                  size: 22
                })
              })
            })]
          })
        })
      }), /*#__PURE__*/_jsx(MenuContent, {
        activeSubMenu: activeSubMenu,
        filtersData: filtersData,
        filtersError: filtersError,
        filtersLoading: filtersLoading,
        isSubMenuOpen: isSubMenuOpen
      })]
    })]
  });
};
const PublicCatalogMobileCategoriesMenuWithContext = ({
  buttonUse,
  buttonText,
  subMenuName
}) => {
  const [MenuStateContext, menuStateContextValue] = useGetMenuStateContextWithValue(subMenuName);
  return /*#__PURE__*/_jsx(MenuStateContext.Provider, {
    value: menuStateContextValue,
    children: /*#__PURE__*/_jsx(PublicCatalogMobileCategoriesMenu, {
      buttonText: buttonText,
      buttonUse: buttonUse
    })
  });
};
export default PublicCatalogMobileCategoriesMenuWithContext;